import Icon from './Icon'
import IconClose from '../icons/IconClose'
import { classify } from '../../helpers'

const Modal = ({ children, value = false, showClose = false, className = '', contentClass = "", onClose }) => {
	return (
		<div
			className={classify(className, "pt-modal fixed flex items-center justify-center", [
				value
					? 'opacity-1 visible inset-0 z-50'
					: 'opacity-0 invisible'
			])}
		>
			<div className={classify("shadow-xl overflow-y-auto scrollbar-y", contentClass)} style={{ maxHeight: '90vh' }}>
				{children}
			</div>
			{showClose && <Icon
				name="close"
				stroke-width="2"
				className="h-8 w-8 lg:h-12 lg:w-12 absolute top-4 right-4 lg:top-8 lg:right-8 cursor-pointer opacity-60 hover:opacity-100"
				onClick={() => onClose && onClose()}
			>
				<IconClose />
			</Icon>}
		</div>
	)
}

export default Modal